/** 用户信息管理的请求方法 */
import http from '@/api/index'
import { DbUser } from '@/api/interface/dbUser.model'
import { PORT1 } from '../config/servicePort'

export class DbUserServer {
  /** 获取用户信息 */
  static getUserinfo() {
    return http.get<DbUser.DbUserinfo>(PORT1 + 'user/online')
  }

  /** 获取用户个人资料信息 POST: /api/common/getUserInfo 参数 { id } */
  static getPersonalInfo(id: number) {
    return http.post<DbUser.PersonalInfoRes>(PORT1 + 'common/common/getUserInfo', { id })
  }

  /** 后台用户个人资料 PUT: /api/common/updateUserInfo/{id} */
  static changePersonalInfo(params: DbUser.DbPersonalInfoReq, id: number) {
    return http.put(PORT1 + `common/common/updateUserInfo/${id}`, params)
  }

  /**修改密码 POST: /api/common/changePassword 参数 { id, old_password, password } */
  static changePasswordInfo(params: DbUser.ChangePasswordReq) {
    return http.post(PORT1 + 'common/common/changePassword', params)
  }

  /** 修改后台用户背景图或头像 PUT: /api/common/updateUserInfo/{id}
   *  updateUserInfo 支持 avatar / bg_image 字段，故头像与背景图更新统一走该接口
   */
  static changeAvatarOrBack(params: DbUser.ChangeBackOrAvatar, id: number) {
    return http.put(PORT1 + `common/common/updateUserInfo/${id}`, params)
  }
}
